module.exports = __webpack_public_path__ + "media/img/pages/companies/jura-45c139bbd7d2716a87a5ddb68eb35666.jpg";